import { useSelectedUserEndpointToken } from 'domains/chains/hooks/useSelectedUserEndpointToken';
import {
  selectBlockchainsLoadingStatus,
  selectConfiguredBlockchainsForToken,
} from 'modules/chains/store/selectors';
import { useAppSelector } from 'store/useAppSelector';

export const usePrivateChainsInfo = () => {
  const userEndpointToken = useSelectedUserEndpointToken();

  const chains = useAppSelector(state =>
    selectConfiguredBlockchainsForToken(state, userEndpointToken),
  );
  const isLoading = useAppSelector(selectBlockchainsLoadingStatus);

  return { chains, isLoading };
};
